(() => {
  function bindMaps(root = document) {
    for (const button of root.querySelectorAll('[data-map-load]')) {
      if (button.dataset.bound) continue;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const panel = button.closest('[data-amoyrc-map]');
        const url = new URL(button.dataset.mapSrc);
        if (url.origin !== 'https://maps.google.com' || url.pathname !== '/maps') return;
        const frame = document.createElement('iframe');
        frame.title = 'Amoyrc business and dispatch address on Google Maps';
        frame.loading = 'lazy';
        frame.referrerPolicy = 'no-referrer-when-downgrade';
        frame.src = url.toString();
        frame.setAttribute('allowfullscreen', '');
        panel.replaceChildren(frame);
      });
    }
  }
  bindMaps();
  document.addEventListener('shopify:section:load', event => bindMaps(event.target));
})();
